import React, { useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'

import { Row, Col, Input, Radio } from 'antd'
import moment from 'moment'

import { validRule, RULES } from '../../../../constants/Entitlements'
import { getMessage } from '../../../../util/IntlMessages'

import './actionStyles.css'

moment.updateLocale(moment.locale('pt-br'), { invalidDate: '-' })

const STATUS = [
  { value: 'ALL', description: getMessage('actions.list.status.all'), class: 'filter-all' },
  { value: 'NAO_PLANEJADA', description: getMessage('actions.list.status.pending'), class: 'filter-not-planned' },
  { value: 'PLANEJADA', description: getMessage('actions.list.status.planned'), class: 'filter-planned' },
  { value: 'REALIZADA', description: getMessage('actions.list.status.finished'), class: 'filter-finished' },
  { value: 'ATRASADA', description: getMessage('actions.list.status.late'), class: 'filter-late' }
]

const messages = {
  allDay: getMessage('calendar.allDay'),
  previous: '<',
  next: '>',
  today: getMessage('calendar.today'),
  month: getMessage('calendar.month'),
  week: getMessage('calendar.week'),
  day: getMessage('calendar.day'),
  agenda: getMessage('calendar.agenda'),
  date: getMessage('calendar.date'),
  time: getMessage('calendar.time'),
  event: getMessage('calendar.event'),
  showMore: (total) => `+ ${getMessage('calendar.showMore')} (${total})`
}

const ActionsCalendar = function ({ data, onLoad, history }) {
  const [searchValues, setSearchValues] = useState({})
  const [statusFilter, setStatusFilter] = useState(STATUS[0].value)
  const setFormDataKey = (key, value) => setSearchValues({ ...searchValues, [key]: value })

  moment.locale('pt-br')
  const localizer = momentLocalizer(moment)

  function onSearch(params) {
    if (params === null) {
      params = { ...searchValues }
    }

    if (typeof onLoad === 'function') {
      onLoad(params)
    }
  }

  function changeStatusFilter(item) {
    const status = item.target.value
    if (status === 'ALL') {
      setStatusFilter(status)
      onSearch()
    } else {
      setStatusFilter(status)
      onSearch({ actionStatus: status })
    }
  }

  function onEventSelect(value) {
    const hasAccess = validRule(RULES.ACTION)
    if (hasAccess) history.push(`/actions/${value.typeId}/${value.id}`)
  }

  function renderFiltros() {
    return (
      <>
        <Row type="flex" justify="start">
          <Col span={8}>
            {getMessage('actions.list.field.filterDescription')}
            <Input.Search
              value={searchValues.actionSubject}
              onChange={(e) => setFormDataKey('actionSubject', e.target.value)}
              onSearch={onSearch}
            />
          </Col>
          <Col span={8}>
            {getMessage('actions.list.field.filterProfessional')}
            <Input.Search
              value={searchValues.memberName}
              onChange={(e) => setFormDataKey('memberName', e.target.value)}
              onSearch={onSearch}
            />
          </Col>
          <Col span={8}>
            {getMessage('actions.list.field.filterStakeholder')}
            <Input.Search
              value={searchValues.customerName}
              onChange={(e) => setFormDataKey('customerName', e.target.value)}
              onSearch={onSearch}
            />
          </Col>
        </Row>
        <Row type="flex" justify="center">
          <Radio.Group value={statusFilter} onChange={changeStatusFilter}>
            {STATUS.map((status) => {
              if (status.value !== 'NAO_PLANEJADA') {
                return (
                  <Radio.Button value={status.value} key={status.value} className={status.class}>
                    {status.description}
                  </Radio.Button>
                )
              }
            })}
          </Radio.Group>
        </Row>
        <br />
        <br />
        <br />
      </>
    )
  }

  function renderEventsWrapper(value) {
    if (value === null) {
      return <>{event.title}</>
    }

    const { event } = value
    if (event) {
      return (
        <div className={`action-item status-${event.className}`}>
          {moment(event.start).format('HH:mm')}
          {` ${event.title} `}
          {event.status}
        </div>
      )
    }
  }

  return (
    <>
      {renderFiltros()}
      <Calendar
        events={data.items}
        localizer={localizer}
        startAccessor="start"
        endAccessor="end"
        messages={messages}
        onSelectEvent={onEventSelect}
        components={{ event: renderEventsWrapper }}
        popup
        toolbar
      />
    </>
  )
}

export default ActionsCalendar
